import React, { useEffect, useState } from "react";
import AppButton from "../../common/AppButton";
import AppInput from "../../common/AppInput";
import numberFormat from "../../common/numberFormat";
import api from "../../config/api";
import colors from "../../config/colors";
import config from "../../config/config";
import { uniqBy } from "lodash";
import moment from "moment";
import { MdMenu } from "react-icons/md";
import { toast } from "react-toastify";
import { getEmployees } from "../../stores/EmployeeStore";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const size = config.iconSize;

export default function EditPaySalary() {
  const [disabled, setDisabled] = useState(false);
  const queryClient = useQueryClient();

  const { data: categories } = useQuery({
    queryFn: () => getEmployees(),
    queryKey: ["employees"],
  });

  const Body = ({ onDone, data }) => {
    const [form, setForm] = useState({
      ...data,
      date: moment(data.date, "DD/MM/YYYY").toDate(),
      comment: data.commentX,
    });

    const handleSubmit = async (event) => {
      event.preventDefault();
      if (!form.employee) {
        document.querySelector("#employee input").focus();
        return false;
      }

      setDisabled(true);
      const res = await api.put("salary", {
        ...form,
      });
      if (!res.ok) {
        setDisabled(false);
        toast.error(res.originalError.message);
      }
      queryClient.invalidateQueries(["salary"]);

      // setForm(formInit);
      setDisabled(false);
      toast.success("Salary has been successfully paid.");

      onDone && onDone();
    };
    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      setForm({ ...form, [name]: value });
    };

    if (!categories) {
      return false;
    }

    return (
      <form id="form" onSubmit={handleSubmit}>
        <br />
        <br />
        <div
          className="d-flex"
          style={{
            gap: "0px 30px",
            padding: "0px 30px",
            minHeight: 400,
            alignItems: "flex-start",
          }}
        >
          <AppInput
            type="date"
            name="date"
            placeholder="Date"
            label="Date"
            floatLabel
            value={form.date}
            onChange={handleChange}
            required
          />
          <AppInput
            type="dropdown"
            name="employee"
            id="employee"
            noClear
            value={form?.employee}
            onChange={handleChange}
            required
            label="Employee"
            filterBy="name"
            floatLabel
            options={uniqBy(
              [form.employee, ...categories],
              (i) => i?._id
            ).sort()}
          />
          <AppInput
            name="amount"
            value={numberFormat(form.amount)}
            onChange={handleChange}
            required
            label="Amount"
            floatLabel
          />
          <AppInput
            name="comment"
            value={form.comment}
            onChange={handleChange}
            required
            label="Comment"
            floatLabel
          />
        </div>
        <br />
        <br />
        <br />
        <br />
      </form>
    );
  };
  const Header = () => {
    return (
      <span className="d-flex" style={{ alignItems: "center" }}>
        <MdMenu size={size} color={colors.silver} style={{ marginRight: 5 }} />
        <b>Edit Salary payment</b>
      </span>
    );
  };
  const Footer = () => {
    return (
      <AppButton
        disabled={disabled}
        text="Save"
        form="form"
        type="submit"
        className="text-primary btn-light"
      />
    );
  };

  return {
    Body,
    Header,
    Footer,
  };
}
